import React from 'react';
import { Checkbox, Form } from 'antd';
import { CheckSquareOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { t } from "@lingui/core/macro";
import { useFormPath } from './index';

export default (formPlugin, namespace) => {
    return {
        Renderer: (props) => {

            const { listFieldProps, buildName } = useFormPath()

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            const { data } = props

            // Required checkbox : on combine la rule "required" Antd avec un validator qui exige `true`
            // (un Checkbox décoché est `false`, qui n'est pas une "valeur vide" pour Antd).
            const rules = []
            if (data.required) {
                rules.push({
                    validator: (_, v) => v === true
                        ? Promise.resolve()
                        : Promise.reject(new Error(t`Ce champ est obligatoire`))
                })
            }

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined />,
                }
            }

            const finalName = "[CHECKBOX]_" + data.fieldKey

            return (
                <Form.Item
                    {...(listFieldProps || {})}
                    name={buildName(finalName)}
                    valuePropName="checked"
                    rules={rules}
                    tooltip={tooltip}
                >
                    <Checkbox size={"middle"}>{data.label}</Checkbox>
                </Form.Item>
            )
        },
        namespace: namespace,
        id: 'form-checkbox' + namespace,
        title: t`Case à cocher`,
        description: t`Élément de formulaire utilisable.`,
        icon: <CheckSquareOutlined />,
        iconColor: "#F39C12",
        version: 1,
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Obligatoire`,
                        }
                    },
                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du champ`,
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },
                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    },
                }
            },
        },
    }
}

